/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Col_TierInputs */

const vi_shop_account_col_tier = /** @type {(inputs: Shop_Account_Col_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạng`)
};

/**

* @param {Shop_Account_Col_TierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_col_tier = /** @type {((inputs?: Shop_Account_Col_TierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Col_TierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_col_tier(inputs)
});